<template>
  <div class="container-fluid px-0 custom-font-size">
    <div class="row mx-0">
      <!-- Business Developments Group -->
      <div class="col-md-5 px-2 mb-3">
        <div class="palette-card">
          <div class="palette-header">
            <b-icon icon="layers-half" class="mr-2 text-primary"></b-icon>
            Business Development
          </div>
          <div class="palette-body">
            <SingleTile
              v-for="tile in projects.filter((tile) => tile.isSystemProject)"
              :key="tile.uid"
              :tile="tile" />
          </div>
        </div>
      </div>
      
      <!-- Client Projects Group -->
      <div class="col-md-7 px-2 mb-3">
        <div class="palette-card">
          <div class="palette-header d-flex justify-content-between align-items-center">
            <span>
              <b-icon icon="briefcase" class="mr-2 text-success"></b-icon>
              Client Projects
            </span>
            <span class="text-muted font-weight-normal text-none text-right" style="font-size: 0.75rem; text-transform: none;">
              Click a tile to select, then click calendar blocks to assign
            </span>
          </div>
          <div class="palette-body">
            <SingleTile
              v-for="tile in projects.filter((tile) => !tile.isSystemProject)"
              :key="tile.uid"
              :tile="tile" />
            <SingleTile
              :ico="!loading ? 'el-icon-refresh' : 'el-icon-loading'"
              :msg="'Get latest changes'"
              :fn="refreshData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Services from '../../../services/main.service.vue'
import SingleTile from './SingleTile.vue'

export default {
  name: 'ProjectTiles',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    projects: {
      type: Array,
      default: () => []
    },
    refreshData: {
      type: Function,
      default: () => {}
    },
    updateCal: {
      type: Function,
      default: () => {}
    }
  },
  components: {
    SingleTile
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    HasAdminPerm() {
      return this.Store.userAuth.hasAdminPrivileges
    },
    StaffingActiveProjects() {
      return this.Store.staffingActiveProjects
    },
    UpdateQueue() {
      return this.Store.assigningQueue
    }
  },
  data() {
    return {
      tiles: []
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped>
.modal-title {
  font-size: 11pt !important;
}
.palette-card {
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
  padding: 14px;
  min-height: 120px;
}
.palette-header {
  font-size: 0.8rem;
  font-weight: 700;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding-bottom: 6px;
  margin-bottom: 10px;
}
.palette-body {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
</style>
